import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_simple_text_cb_with_fallback = _resolveComponent("simple-text-cb-with-fallback")!

  return (_openBlock(), _createBlock(_component_simple_text_cb_with_fallback, {
    title: _ctx.$t('generalTerms'),
    "cb-type": $data.cbType
  }, null, 8, ["title", "cb-type"]))
}